import { Page } from '@app/components/page/Page';
import { AdminModule } from '@app/modules/admin/index';
import { Station } from '@mi-front/core';
import compact from 'lodash/compact';
import { FormattedMessage } from 'react-intl';

interface Props {
  readonly title?: string;
  readonly active?: Station;
}

export const AdminStationsBreadcrumbs = (p: Props) => {
  const items = compact([
    {
      content: <FormattedMessage id="common.entities.stations" defaultMessage="Emisoras" />,
      href: '/admin/stations',
    },
    p.active && {
      content: p.active.name,
      href: `/admin/stations/${p.active.slug}`,
    },
    // {
    //   content: p.title,
    //   active: true,
    // },
  ]);

  return <Page.ModuleBreadcrumbs module={AdminModule} items={items} />;
};
